import { useInt } from 'hooks/useInt';

import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';
import type { NumberedFeatureCard } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards.types';

type Translate = (key: string) => string;

const getItems = (t: Translate): NumberedFeatureCard[] => [
  {
    num: '01',
    tag: t('Resolve → Verify → Cite → Log'),
    title: t('KYB API for onboarding agents'),
    description: t(
      'KYB automation for onboarding. Takes a company name from an application form, resolves it to the register, verifies status and officers, and writes a sourced decision to the case file.',
    ),
    note: t('Banking · Fintech · Marketplaces'),
  },
  {
    num: '02',
    tag: t('Resolve'),
    title: t('Entity resolution software for agents'),
    description: t(
      'Deduplicates and matches company records across a CRM, a supplier master and an external list, on registration number rather than string similarity.',
    ),
    note: t('Technology · Data teams'),
  },
  {
    num: '03',
    tag: t('All six steps as tools'),
    title: t('Claude MCP server for company data'),
    description: t(
      'The dataset exposed as MCP tools so an assistant or in-house agent framework calls it directly and receives sourced values.',
    ),
    note: t('AI platform teams'),
  },
  {
    num: '04',
    tag: t('Traverse → Cite'),
    title: t('UBO verification for AML agents'),
    description: t(
      'Walks a shareholding chain across jurisdictions to the natural persons in control, each hop returned against the register that recorded it.',
    ),
    note: t('Banking · Legal · Public sector'),
  },
  {
    num: '05',
    tag: t('Read financials → Cite'),
    title: t('Company financials for underwriting agents'),
    description: t(
      'Filed accounts as structured fields by period, so an underwriting agent reads turnover, assets and liabilities from the statutory filing and cites the document.',
    ),
    note: t('Insurance · Commercial lending'),
  },
  {
    num: '06',
    tag: t('Verify → Traverse → Log'),
    title: t('Supplier verification for procurement agents'),
    description: t(
      'Confirms a bidder or supplier is registered, active and owned by whom it declares, before a purchase order or contract award is issued.',
    ),
    note: t('Public sector · Manufacturing'),
  },
];

export const CompanyDataWorkflows = () => {
  const { t } = useInt();

  return (
    <NumberedFeatureCards
      theme="light"
      columns={3}
      title={t('Where this data layer is already doing the work.')}
      description={t(
        'AI agents for compliance, banking and financial services run the same six steps against one decision. Each workflow below links to the industry where it is most often deployed.',
      )}
      items={getItems(t)}
    />
  );
};
